import { render } from "./CompaniesList.vue?vue&type=template&id=1be86b38&scoped=true&ts=true"
import script from "./CompaniesList.vue?vue&type=script&lang=ts"
export * from "./CompaniesList.vue?vue&type=script&lang=ts"

import "./CompaniesList.vue?vue&type=style&index=0&id=1be86b38&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be86b38"]])

export default __exports__